import React from 'react';
import {
    Link
} from "react-router-dom";
import { withRouter } from "react-router";
import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn } from 'mdbreact';
import './LoginScreen.css';


class LoginScreen extends React.Component {

    constructor(props) {
        super(props);
        this.login = this.login.bind(this);
        // this.usernameChange = this.usernameChange.bind(this);
        // this.passwordChange = this.passwordChange.bind(this);
        this.state = {
            userName: "",
            password: "",
            userNameRequired : false,
            passwordRequired : false
        };
    }

    validform() 
    {
      const {username , password} = this.state;
      let validFormFlag = false;
      if(username === ''){
        this.setState({ userNameRequired : true });
        return validFormFlag;
      } 
      else if(password === ''){
        this.setState({ passwordRequired : true});
        return validFormFlag;
      }
      else {
        return true;
      }
    }

    login() {
        if(this.validform)
        {
        let postData = {};
        postData.userName = this.state.userName;
        postData.password = this.state.password;
        console.log(postData);

        fetch('', 
          {
            method : 'post',
            headers : {
              'Content-Type' : 'application/json'
            },
            body : JSON.stringify(postData)
          }).then((res) => res.json())
          .then((data) => console.log(data))
          .catch((err) => console.log(err))

        this.props.history.push({ pathname: `/dashboard/${this.state.username}`, state: {username: this.state.username , password:this.state.password} });
        }
    }

    // usernameChange(event) {
    //     this.setState({ username: event.currentTarget.value})
    // }

    // passwordChange(event) {
    //     this.setState({ password: event.currentTarget.value})
    // }
    handleFormFields = (event) => {
      // console.log(event.target.id)
      switch (event.target.id) { 
        case "lemail":
          this.setState({ "userName": event.target.value });
          break;
        case "lpassword":
          this.setState({ "password": event.target.value });
          break;
        default:
				break;
		}

	}
    render() {
        return (
            <>
            <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <form>
            <p className="h5 text-center mb-4">Sign in</p>
            <div className="grey-text">
              <MDBInput
                label="Type your email"
                id="lemail"
                icon="envelope"
                required group
                type="email"
                validate
                error="wrong"
                success="right"
                value={this.state.userName} onChange={this.handleFormFields}
              />
              <MDBInput
                label="Type your password"
                id="lpassword"
                icon="lock"
                required group
                type="password"
                value = {this.state.password} onChange={this.handleFormFields}
                
              />
            </div>
            <div className="text-center">
              <MDBBtn onClick={this.login}> Login</MDBBtn>
            </div>
          </form>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
            </>

        )
    }
}

export default withRouter(LoginScreen);